import React from "react"

const Alert = React.forwardRef(({ 
  className = "", 
  variant = "default", 
  children, 
  ...props 
}, ref) => {
  const getVariantClasses = () => {
    switch (variant) {
      case "default":
        return "bg-white text-gray-900 border-gray-200"
      case "destructive":
        return "border-red-200 text-red-700 bg-red-50 [&>svg]:text-red-600"
      default:
        return "bg-white text-gray-900 border-gray-200"
    }
  }

  return (
    <div
      ref={ref}
      role="alert"
      className={`
        relative w-full rounded-lg border p-4 
        [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] 
        [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-gray-900
        ${getVariantClasses()}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  )
})

Alert.displayName = "Alert"

const AlertTitle = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <h5
    ref={ref}
    className={`mb-1 font-medium leading-none tracking-tight ${className}`}
    {...props}
  >
    {children}
  </h5>
))

AlertTitle.displayName = "AlertTitle"

const AlertDescription = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <div
    ref={ref}
    className={`text-sm [&_p]:leading-relaxed ${className}`}
    {...props}
  >
    {children}
  </div>
))

AlertDescription.displayName = "AlertDescription"

export { Alert, AlertTitle, AlertDescription } 